import React from "react";
import { AbstractDate } from "@linkfluence/models/date";
import { DatavizKpi } from "@radarly/models/dataviz";
import { SearchFragmentDateMetrics } from "@radarly/models/search";
import { useFragmentsData } from "../../data";
import Loading from "../../loading";
import Inner from "./inner";

export type SharedWidgetsKpiProps = {
  fragment: SearchFragmentDateMetrics;
  dataviz: DatavizKpi;
  project: number;
  evolutionFragment?: SearchFragmentDateMetrics;
  onClick?: () => void;
  className?: string;
  forceReload?: boolean;
  disableAnimation?: boolean;
  nowDate?: AbstractDate;
  isFullscreen?: boolean;
  closeFullscreen?: () => void;
};

export default function SharedWidgetsKpi({
  project,
  fragment,
  evolutionFragment,
  forceReload,
  isFullscreen,
  closeFullscreen,
  onClick,
  ...props
}: SharedWidgetsKpiProps) {
  const { loading, data, comparaisonData } = useFragmentsData(
    project,
    fragment,
    evolutionFragment
  );
  const _onClick = () => {
    if (isFullscreen) {
      closeFullscreen();
    }
    onClick();
  };
  return (
    <Loading loading={loading} forceReload={forceReload}>
      <Inner
        loading={loading}
        data={data}
        comparaisonData={comparaisonData}
        fragment={fragment}
        evolutionFragment={evolutionFragment}
        isFullscreen={isFullscreen}
        onClick={onClick && _onClick}
        {...props}
      />
    </Loading>
  );
}
